export function typingRender() { return `<div class="typingCont">
    <div class="typing" style="${ this.__$objToStyleMap(this.style) }" tabindex="-1">
        ${ this.showTypingAnimation ? `<div aria-label="${this.ariaLabel}">
            ${ this.typingElipsisStyles.map(function(item) { return `<div class="ellipsis" style="${ this.__$objToStyleMap(item) }"></div>`}.bind(this)).join('') }
        </div>`
        :`<div class="typing-text"></div>` }
    </div>
</div>` }